import { Visibility as SeeIcon } from '@material-ui/icons'
import { useState } from 'react'
import { Modal } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { setViewingUser, patchUser } from '../state/trackingSlice2'
import ProfileModal from './ProfileModal'
import { User } from '@types'

interface Props {
  userId: string
  isTeam: boolean
}

const SeeIconModal: React.FC<Props> = ({ userId, isTeam }) => {
  const [isOpen, setIsOpen] = useState(false)
  const dispatch = useDispatch()

  const handleClick = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    e.preventDefault()
    dispatch(setViewingUser(userId))
    setIsOpen(true)
  }

  const handleChangeUser = (dataProfile: User) => {
    dispatch(patchUser({ dataProfile, isTeam }))
  }

  return (
    <div>
      <SeeIcon
        style={{
          color: 'rgb(255, 105, 0)',
          width: '20px',
          height: '20px',
          margin: '0 10px',
          cursor: 'pointer',
          marginTop: '10px'
        }}
        onClick={e => handleClick(e)}
      />
      <Modal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <div
          style={{
            width: '500px',
            background: 'white',
            borderRadius: '10px',
            overflow: 'hidden',
            position: 'relative'
          }}
        >
          <ProfileModal handleChangeUser={handleChangeUser} onClick={() => setIsOpen(false)} />
        </div>
      </Modal>
    </div>
  )
}

export default SeeIconModal
